module.exports = __webpack_public_path__ + "static/media/big_smartsampa_logo_dark.3e2fad7f.png";